import { useContext } from 'react';
import { OnStartWarningHook } from '../../../../_Common/Const/Rutiner';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { useQuery } from '@apollo/client';
import HarNagonKodbehorighetQuery from '../Queries/EkonomiskAnalysHarNagonKodbehorighetQuery/EkonomiskAnalysHarNagonKodbehorighetQuery.gql';
import {
  EkonomiskAnalysHarNagonKodbehorighetQueryVariables,
  EkonomiskAnalysHarNagonKodbehorighetQuery,
} from '../Queries/EkonomiskAnalysHarNagonKodbehorighetQuery/_QueryTypes/EkonomiskAnalysHarNagonKodbehorighetQuery';
import { KodplanContext } from '../../../../../../Components/KodplanManager/Context/KodplanContext';

export const useEkonomiskAnalysOnStartWarningHook: OnStartWarningHook =
  isLoggedIn => {
    const activeDatabase = useContext(ActiveDatabaseContext);
    const { activeKodplan } = useContext(KodplanContext);
    const skip =
      !activeDatabase.activeDatabase || !activeKodplan?.id || !isLoggedIn;

    const { data, loading } = useQuery<
      EkonomiskAnalysHarNagonKodbehorighetQuery,
      EkonomiskAnalysHarNagonKodbehorighetQueryVariables
    >(HarNagonKodbehorighetQuery, {
      fetchPolicy: 'network-only',
      variables: {
        dbname: activeDatabase.activeDatabase || '',
        kodplanid: activeKodplan?.id ?? '',
      },
      skip: skip,
    });

    return {
      loading: loading || skip,
      ok: !loading && Boolean(data?.me?.[0]?.hasAnyAnalysKodbeh),
      warningText: 'Du har ingen kodbehörighet markerad för analys.',
    };
  };
